import type { ElementType, FC } from 'react';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';

export type LogotypeExampleUsageType = {
    image: LocalImageProps;
    description: string;
    Icon: ElementType;
    iconProps?: React.HTMLAttributes<HTMLElement>;
};

export interface LogotypesExamplesProps {
    logotypes: LocalImageProps[];
    logotypeExampleUsage?: LogotypeExampleUsageType[];
}

const LogotypesExamples: FC<LogotypesExamplesProps> = ({
    logotypes,
    logotypeExampleUsage,
}) => (
    <>
        <div className="mb-8 mt-10 flex flex-wrap items-center gap-6">
            {logotypes.map((logotype, i) => (
                <LocalImage
                    key={i}
                    {...logotype}
                />
            ))}
        </div>

        <ul className="flex flex-wrap gap-4">
            {logotypeExampleUsage?.map(
                (imageUsage: LogotypeExampleUsageType, i: number) => {
                    const { image, Icon, iconProps, description } = imageUsage;

                    return (
                        <li
                            key={image.src || `logotype-${i}`}
                            className="mb-4 w-full md:w-[48%] [&:nth-last-child(-n+2)]:mb-0"
                        >
                            <LocalImage {...image} />

                            <div className="mb-1 mt-3 flex gap-2">
                                {!!Icon && (
                                    <Icon
                                        alt=""
                                        size={32}
                                        className="shrink-0"
                                        {...iconProps}
                                    />
                                )}

                                <p className="text-xs">{description}</p>
                            </div>
                        </li>
                    );
                },
            )}
        </ul>
    </>
);

export default LogotypesExamples;
